import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectReservation = createFeatureSelector<any>('reservation');

export const selectReservationState = createSelector(
    selectReservation,
    (state: any) => state,
);
